import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { TrendingUp } from 'lucide-react';

const COLORS = ['#01796d', '#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981'];

export function OrderSourceChart({ data }) {
  console.log('OrderSourceChart data:', data);
  
  // Process the order source data
  const processSourceData = (inputData) => {
    if (!inputData) return [];

    // If data is already in the expected format with name/orders
    if (Array.isArray(inputData) && inputData.length > 0) {
      // Check if it's already formatted correctly
      if (inputData[0].name !== undefined && inputData[0].orders !== undefined) {
        return inputData.filter(item => item.orders > 0);
      }

      // Transform from source/count format to name/orders format
      const transformedData = inputData
        .filter(item => (item.count || item.OrderCount || 0) > 0)
        .map(item => ({
          name: item.source || item.OrderSource || 'Unknown',
          orders: item.count || item.OrderCount || 0
        }));
      
      return transformedData;
    }

    return [];
  };

  const processedData = processSourceData(data);
  
  // Add defensive check
  if (!processedData || processedData.length === 0) {
    return (
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Order Sources</h3>
            <p className="text-sm text-slate-500 mt-1">Distribution by channel</p>
          </div>
          <div className="bg-gradient-to-br from-[#01796d] to-teal-600 p-3 rounded-xl shadow-lg">
            <TrendingUp className="w-5 h-5 text-white" />
          </div>
        </div>
        <div className="text-center py-8 text-slate-400">
          No order source data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200 hover:shadow-xl transition-all">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-slate-900">Order Sources</h3>
          <p className="text-sm text-slate-500 mt-1">Distribution by channel</p>
        </div>
        <div className="bg-gradient-to-br from-[#01796d] to-teal-600 p-3 rounded-xl shadow-lg">
          <TrendingUp className="w-5 h-5 text-white" />
        </div>
      </div>

      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={processedData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: '#64748b', fontSize: 12 }}
              axisLine={{ stroke: '#e2e8f0' }}
            />
            <YAxis 
              tick={{ fill: '#64748b', fontSize: 12 }}
              axisLine={{ stroke: '#e2e8f0' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
              }}
              formatter={(value) => [`${value} orders`, 'Orders']}
            />
            <Bar dataKey="orders" radius={[8, 8, 0, 0]}>
              {processedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-6">
        {processedData.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full shadow-md"
              style={{ backgroundColor: COLORS[index % COLORS.length] }}
            ></div>
            <span className="text-xs text-slate-600">{item.name}: {item.orders}</span>
          </div>
        ))}
      </div>
    </div>
  );
}